import { Box, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import useAPI from "../../../../api/hooks/useAPI";
import { remediationKeys } from "../../../../api/queryKeys";
import LoadingIcon from "../../../../components/LoadingIcon";
import CompensatingControlsTable from "./CompensatingControlsTable";

export default function CompensatingControls({
  selectedVulnerability,
  selectedTenantIds,
  hasMultipleSelectedTenants,
  entityIds,
}) {
  const { fetchRemediationsBatch } = useAPI();

  //TODO:for convenience, I'm currently using remediation ids instead of control ids for the attribute "compensating_control_ids." We will need to replace this in the future.
  const remediationsQuery = useQuery({
    queryKey: remediationKeys.batchRemediations(
      selectedVulnerability?.compensating_control_ids
    ),
    queryFn: async () => {
      return await fetchRemediationsBatch(
        selectedVulnerability?.compensating_control_ids
      );
    },
    select: (response) => response.data,
    enabled: selectedVulnerability !== null,
  });

  return (
    <>
      {remediationsQuery.isLoading ? (
        <LoadingIcon />
      ) : remediationsQuery.isSuccess &&
        remediationsQuery.data?.length > 0 &&
        !hasMultipleSelectedTenants ? (
        <Box display={"flex"} flexDirection={"column"} gap={3}>
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Typography variant="subtitle1">Compensating Controls</Typography>
            <Typography variant="body2">
              Apply these controls to reduce the impact of this CVE exploitation
            </Typography>
          </Box>
          <Box sx={{ width: "100%" }}>
            <CompensatingControlsTable
              selectedVulnerability={selectedVulnerability}
              affectedEntityIdsFilter={entityIds}
              remediations={remediationsQuery.data}
            />
          </Box>
        </Box>
      ) : null}
    </>
  );
}
